import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Starred from '@/views/Starred'
import Completed from '@/views/Completed'
import Deleted from '@/views/Deleted'
import About from '@/views/About'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
import Signup from '@/views/Signup'
import store from '@/store'
import PageNotFound from '@/views/PageNotFound'
import ResetPassword from '@/views/ResetPassword'
import Settings from '@/views/Settings'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      name: 'Home',
    },
    {
      path: '*',
      component: PageNotFound,
      name: 'PageNotFound',
    },
    {
      path: '/dashboard',
      component: Dashboard,
      name: 'Dashboard',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/starred',
      component: Starred,
      name: 'Starred',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/completed',
      component: Completed,
      name: 'Completed',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/deleted',
      component: Deleted,
      name: 'Deleted',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: '/password-reset',
      component: ResetPassword,
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: '/signup',
      component: Signup,
      name: 'Signup',
      meta: {
        requiresNoAuth: true,
      },
    },
    {
      path: '/about',
      component: About,
      name: 'About',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/settings',
      component: Settings,
      name: 'Settings',
      meta: {
        requiresAuth: true,
      },
    },
  ],
})

/*
 * Navigation guard config
 * (1) Require auth for account related pages, redirect to login if not
 * (2) Require user to NOT be signed in to access signup / login pages, otherwise redirect dashboard
 * */
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.authenticated
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth)
  const requiresNoAuth = to.matched.some((x) => x.meta.requiresNoAuth)
  if (requiresAuth && !isAuthenticated) {
    next('login')
  } else if (requiresAuth && isAuthenticated) {
    next()
  } else if (requiresNoAuth && isAuthenticated) {
    next('dashboard')
  } else {
    next()
  }
})

export default router
